import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  class: "head"
};

var _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "width": "3.5rem",
    "color": "#cccccc"
  }
}, "搜索想要的号码", -1);

var _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "search-btn"
}, "搜 索", -1);

var _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "order_div"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "search-ul"
}, [/*#__PURE__*/_createElementVNode("a", null, "模糊搜索"), /*#__PURE__*/_createElementVNode("a", null, "精确搜索")])], -1);

var _hoisted_5 = {
  style: {
    "padding": "5px 16px"
  }
};
var _hoisted_6 = {
  style: {
    "padding": "5px 16px"
  }
};

var _hoisted_7 = /*#__PURE__*/_createTextVNode(" 确认 ");

var _hoisted_8 = {
  style: {
    "margin-top": "0.1rem",
    "margin-bottom": "1.56rem"
  }
};
var _hoisted_9 = {
  class: "phone_number_article"
};
var _hoisted_10 = ["onClick"];
var _hoisted_11 = {
  class: "liang_phonenumber"
};
var _hoisted_12 = ["innerHTML"];
var _hoisted_13 = {
  key: 0,
  class: "liang_flag"
};
var _hoisted_14 = {
  class: "opt_Id"
};
var _hoisted_15 = {
  key: 0
};
var _hoisted_16 = {
  key: 1
};
var _hoisted_17 = {
  key: 2
};
var _hoisted_18 = {
  key: 3
};
var _hoisted_19 = {
  key: 4
};
var _hoisted_20 = {
  class: "price"
};
var _hoisted_21 = {
  key: 0,
  style: {
    "text-align": "center",
    "font-size": "0.18rem",
    "margin": "0.5rem",
    "color": "#c2c2c2"
  }
};

var _hoisted_22 = /*#__PURE__*/_createElementVNode("div", null, "数据加载中，请耐心等待...", -1);

var _hoisted_23 = {
  class: "order_div"
};
var _hoisted_24 = {
  class: "subject1"
};
var _hoisted_25 = {
  class: "liang_phonenumber1"
};
var _hoisted_26 = {
  class: "text-area1"
};
var _hoisted_27 = {
  key: 0
};
var _hoisted_28 = {
  key: 1
};
var _hoisted_29 = {
  key: 2
};
var _hoisted_30 = {
  key: 3
};
var _hoisted_31 = {
  key: 4
};
var _hoisted_32 = {
  class: "packageTable"
};

var _hoisted_33 = /*#__PURE__*/_createElementVNode("td", {
  class: "title"
}, "开户套餐", -1);

var _hoisted_34 = /*#__PURE__*/_createElementVNode("td", {
  class: "title"
}, "月费", -1);

var _hoisted_35 = {
  key: 0
};

var _hoisted_36 = /*#__PURE__*/_createElementVNode("td", {
  class: "title"
}, "优惠", -1);

var _hoisted_37 = /*#__PURE__*/_createElementVNode("td", {
  class: "title"
}, "套餐内", -1);

var _hoisted_38 = /*#__PURE__*/_createElementVNode("td", {
  class: "title"
}, "套餐外", -1);

var _hoisted_39 = {
  key: 1
};

var _hoisted_40 = /*#__PURE__*/_createElementVNode("td", {
  class: "title"
}, "合约", -1);

var _hoisted_41 = {
  key: 0
};

var _hoisted_42 = /*#__PURE__*/_createTextVNode("号码月保底消费");

var _hoisted_43 = {
  class: "red"
};

var _hoisted_44 = /*#__PURE__*/_createTextVNode("元 ");

var _hoisted_45 = {
  key: 1
};

var _hoisted_46 = /*#__PURE__*/_createTextVNode("号码要求在网时长");

var _hoisted_47 = {
  class: "red"
};

var _hoisted_48 = /*#__PURE__*/_createTextVNode("个月");

var _hoisted_49 = /*#__PURE__*/_createElementVNode("div", {
  class: "order_info1"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "red"
}, "*"), /*#__PURE__*/_createTextVNode("请务必填写正确的入网信息"), /*#__PURE__*/_createElementVNode("span", {
  class: "red"
}, "*")], -1);

var _hoisted_50 = /*#__PURE__*/_createTextVNode(" 我已阅读并同意 ");

var _hoisted_51 = /*#__PURE__*/_createElementVNode("span", {
  class: "blue"
}, "《入网协议》", -1);

var _hoisted_52 = /*#__PURE__*/_createTextVNode(" 和 ");

var _hoisted_53 = /*#__PURE__*/_createElementVNode("span", {
  class: "blue"
}, "《关于客户个人信息收集、使用规则的公告》", -1);

var _hoisted_54 = {
  key: 0
};

var _hoisted_55 = /*#__PURE__*/_createTextVNode("和 ");

var _hoisted_56 = /*#__PURE__*/_createElementVNode("span", {
  class: "blue"
}, "《靓号入网补充协议》", -1);

var _hoisted_57 = [_hoisted_55, _hoisted_56];

var _hoisted_58 = /*#__PURE__*/_createElementVNode("span", {
  class: "blue"
}, "《中国电信用户入网协议（2024线上版）》", -1);

var _hoisted_59 = /*#__PURE__*/_createTextVNode(" 和 ");

var _hoisted_60 = /*#__PURE__*/_createElementVNode("span", {
  class: "blue"
}, "《法律风险告知书》", -1);

var _hoisted_61 = [_hoisted_58, _hoisted_59, _hoisted_60];

var _hoisted_62 = /*#__PURE__*/_createElementVNode("span", {
  class: "blue"
}, "《中国广电移动电话通信业务入网服务协议（V1.0）》", -1);

var _hoisted_63 = [_hoisted_62];

var _hoisted_64 = /*#__PURE__*/_createElementVNode("span", {
  class: "blue"
}, "《中国移动通信客户服务协议》", -1);

var _hoisted_65 = /*#__PURE__*/_createTextVNode(" 和");

var _hoisted_66 = /*#__PURE__*/_createElementVNode("span", {
  class: "blue"
}, "《实名制信息安全责任告知书》", -1);

var _hoisted_67 = /*#__PURE__*/_createTextVNode(" 和");

var _hoisted_68 = /*#__PURE__*/_createElementVNode("span", {
  class: "blue"
}, "《关于客户个人信息收集、使用及保护的公告》", -1);

var _hoisted_69 = [_hoisted_64, _hoisted_65, _hoisted_66, _hoisted_67, _hoisted_68];
var _hoisted_70 = {
  class: "pay_div"
};
var _hoisted_71 = {
  class: "content"
};
var _hoisted_72 = {
  style: {
    "font-size": "0.26rem"
  }
};

var _hoisted_73 = /*#__PURE__*/_createTextVNode("合计：");

var _hoisted_74 = {
  class: "red"
};

var _hoisted_75 = /*#__PURE__*/_createTextVNode(" 价格明细 ");

var _hoisted_76 = /*#__PURE__*/_createTextVNode("立即预约");

var _hoisted_77 = {
  class: "fee_detail"
};
var _hoisted_78 = {
  style: {
    "width": "100%",
    "border-bottom": "0.01rem solid #cccccc"
  }
};

var _hoisted_79 = /*#__PURE__*/_createElementVNode("span", null, "服务费", -1);

var _hoisted_80 = {
  style: {
    "width": "100%"
  }
};

var _hoisted_81 = /*#__PURE__*/_createElementVNode("span", null, "话费", -1);

var _hoisted_82 = /*#__PURE__*/_createElementVNode("div", {
  class: "buy_know"
}, [/*#__PURE__*/_createElementVNode("h4", null, "购买须知"), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "border": "0.01rem solid #ffffff"
  }
}), /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("label", null, "1、"), /*#__PURE__*/_createTextVNode("根据工信部2018年9月1日实名新规要求，您下单时需填写真实姓名和身份证号进行实名认证，电话卡收到后需激活才能使用。激活时需上传身份证正面、反面以及本人正面免冠照片，下单填写的姓名和身份证信息需要与实名登记的信息一致，审核通过后才能激活使用。 ")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("label", null, "2、"), /*#__PURE__*/_createTextVNode("预约订单提交成功后，系统会进行购买资格审核认证，认证通过会进行正式单下单然后制卡发货。认证失败将会全额退款。")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("label", null, "3、"), /*#__PURE__*/_createTextVNode("号码制卡成功发货后激活前退单请联系客服协商能否退款。")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("label", null, "4、"), /*#__PURE__*/_createTextVNode("由于手机号码属于一卡一号，一旦售出完成实名制激活后无法进行退换货，请谨慎购买。")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("label", null, "5、"), /*#__PURE__*/_createTextVNode("请保持手机畅通以便于工作人员随时联系到您。")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("label", null, "6、"), /*#__PURE__*/_createTextVNode("若需开具发票，请联系客服。本司仅开取服务费的发票金额，号码包含的话费金额为运营商收取，发票可在运营商系统开取。")])])], -1);

var _hoisted_83 = {
  key: 0
};

var _hoisted_84 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "7.5rem",
    "height": "2.0rem",
    "margin": "0 auto"
  }
}, null, -1);

var _hoisted_85 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "7.5rem",
    "height": "0.1rem",
    "margin": "0 auto",
    "position": "fixed",
    "bottom": "0"
  }
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_icon = _resolveComponent("van-icon");

  var _component_van_nav_bar = _resolveComponent("van-nav-bar");

  var _component_van_popup = _resolveComponent("van-popup");

  var _component_van_picker = _resolveComponent("van-picker");

  var _component_van_dropdown_item = _resolveComponent("van-dropdown-item");

  var _component_van_switch = _resolveComponent("van-switch");

  var _component_van_cell = _resolveComponent("van-cell");

  var _component_van_button = _resolveComponent("van-button");

  var _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu");

  var _component_van_list = _resolveComponent("van-list");

  var _component_van_image = _resolveComponent("van-image");

  var _component_van_field = _resolveComponent("van-field");

  var _component_van_checkbox = _resolveComponent("van-checkbox");

  var _component_van_cell_group = _resolveComponent("van-cell-group");

  var _component_van_form = _resolveComponent("van-form");

  var _component_UnicomInNetProtocol = _resolveComponent("UnicomInNetProtocol");

  var _component_TelcomNetProtocol = _resolveComponent("TelcomNetProtocol");

  var _component_BroadNetProtocol = _resolveComponent("BroadNetProtocol");

  var _component_MobileNetProtocol = _resolveComponent("MobileNetProtocol");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_icon, {
    name: "wap-home-o",
    style: {
      "margin": "0.3rem"
    },
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$router.push('/');
    })
  }), _createElementVNode("div", {
    class: "search-div",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $data.numberKeyPopup = true;
    })
  }, [_createVNode(_component_van_icon, {
    name: "search"
  }), _hoisted_2, _hoisted_3])]), _createVNode(_component_van_popup, {
    show: $data.numberKeyPopup,
    "onUpdate:show": _cache[3] || (_cache[3] = function ($event) {
      return $data.numberKeyPopup = $event;
    }),
    position: "bottom",
    style: {
      "height": "100%"
    }
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_nav_bar, {
        "left-arrow": "",
        "left-text": "返回",
        style: {
          "width": "7.5rem",
          "margin": "0 auto"
        },
        title: "号码数字搜索",
        onClickLeft: _cache[2] || (_cache[2] = function ($event) {
          return $data.numberKeyPopup = false;
        })
      }), _hoisted_4];
    }),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_dropdown_menu, {
    ref: "menuRef"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_dropdown_item, {
        ref: "ascriptionRef",
        title: $data.queryObj.area,
        style: {
          "width": "7.5rem",
          "margin": "0 auto"
        }
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_5, [_createVNode(_component_van_picker, {
            modelValue: $data.ascriptionAreaCode,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
              return $data.ascriptionAreaCode = $event;
            }),
            columns: $data.ascriptionList,
            onCancel: $options.closeAscription,
            onConfirm: $options.confirmAscription,
            "toolbar-position": "bottom"
          }, null, 8, ["modelValue", "columns", "onCancel", "onConfirm"])])];
        }),
        _: 1
      }, 8, ["title"]), _createVNode(_component_van_dropdown_item, {
        modelValue: $data.queryObj.optId,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
          return $data.queryObj.optId = $event;
        }),
        options: $data.optIds,
        onChange: $options.confirmOpt,
        style: {
          "width": "7.5rem",
          "margin": "0 auto"
        }
      }, null, 8, ["modelValue", "options", "onChange"]), _createVNode(_component_van_dropdown_item, {
        title: "筛选",
        ref: "itemRef"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_cell, {
            center: "",
            title: "包邮"
          }, {
            "right-icon": _withCtx(function () {
              return [_createVNode(_component_van_switch, {
                modelValue: _ctx.switch1,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
                  return _ctx.switch1 = $event;
                })
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_van_cell, {
            center: "",
            title: "团购"
          }, {
            "right-icon": _withCtx(function () {
              return [_createVNode(_component_van_switch, {
                modelValue: _ctx.switch2,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
                  return _ctx.switch2 = $event;
                })
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }), _createElementVNode("div", _hoisted_6, [_createVNode(_component_van_button, {
            type: "primary",
            block: "",
            round: "",
            onClick: _ctx.onConfirm
          }, {
            default: _withCtx(function () {
              return [_hoisted_7];
            }),
            _: 1
          }, 8, ["onClick"])])];
        }),
        _: 1
      }, 512)];
    }),
    _: 1
  }, 512), _createElementVNode("div", _hoisted_8, [_createVNode(_component_van_list, {
    modelValue: $data.loading,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
      return $data.loading = $event;
    }),
    finished: $data.finished,
    "finished-text": $data.result,
    onLoad: $options.loadData
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("article", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item,
          class: "phonelist",
          onClick: function onClick($event) {
            return $options.openOrder(item);
          }
        }, [_createElementVNode("span", _hoisted_11, [_createElementVNode("span", {
          innerHTML: item.display
        }, null, 8, _hoisted_12), item.onlineMonths != 0 ? (_openBlock(), _createElementBlock("span", _hoisted_13, "靓")) : _createCommentVNode("", true)]), _createElementVNode("span", _hoisted_14, [item.optId == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_15, "中国移动")) : item.optId == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_16, "中国联通")) : item.optId == 3 ? (_openBlock(), _createElementBlock("span", _hoisted_17, "中国电信")) : item.optId == 5 ? (_openBlock(), _createElementBlock("span", _hoisted_18, "中国广电")) : item.optId == 4 ? (_openBlock(), _createElementBlock("span", _hoisted_19, "民营运营商")) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(item.area), 1)]), _createElementVNode("span", _hoisted_20, "￥" + _toDisplayString(item.costPrice + item.fee) + " （含话费￥" + _toDisplayString(item.fee) + "）", 1)], 8, _hoisted_10);
      }), 128))])];
    }),
    _: 1
  }, 8, ["modelValue", "finished", "finished-text", "onLoad"]), $data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createVNode(_component_van_image, {
    src: require('@/assets/images/loading.gif'),
    style: {
      "width": "0.5rem"
    }
  }, null, 8, ["src"]), _hoisted_22])) : _createCommentVNode("", true)]), _createVNode(_component_van_popup, {
    show: $data.showBsp,
    "onUpdate:show": _cache[9] || (_cache[9] = function ($event) {
      return $data.showBsp = $event;
    }),
    position: "bottom"
  }, null, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $data.show,
    "onUpdate:show": _cache[24] || (_cache[24] = function ($event) {
      return $data.show = $event;
    }),
    position: "bottom",
    style: {
      "height": "100%"
    }
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_nav_bar, {
        "left-arrow": "",
        "left-text": "返回",
        style: {
          "width": "7.5rem",
          "margin": "0 auto"
        },
        title: "立即预约",
        onClickLeft: _cache[10] || (_cache[10] = function ($event) {
          return $data.show = false;
        })
      }), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createVNode(_component_van_image, {
        src: require('@/assets/images/sim-card.png'),
        class: "sim_card"
      }, null, 8, ["src"]), _createTextVNode(" " + _toDisplayString($data.phoneObj.phoneNumber), 1)]), _createElementVNode("div", _hoisted_26, [_createVNode(_component_van_image, {
        src: require('@/assets/images/ascription_icon.png'),
        class: "sim_card"
      }, null, 8, ["src"]), _createTextVNode("  " + _toDisplayString($data.phoneObj.province) + "  " + _toDisplayString($data.phoneObj.area) + "   ", 1), $data.phoneObj.optId == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_27, "中国移动")) : $data.phoneObj.optId == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_28, "中国联通")) : $data.phoneObj.optId == 3 ? (_openBlock(), _createElementBlock("span", _hoisted_29, "中国电信")) : $data.phoneObj.optId == 4 ? (_openBlock(), _createElementBlock("span", _hoisted_30, "民营运营商")) : $data.phoneObj.optId == 5 ? (_openBlock(), _createElementBlock("span", _hoisted_31, "中国广电")) : _createCommentVNode("", true)])]), _createElementVNode("table", _hoisted_32, [_createElementVNode("tr", null, [_hoisted_33, _createElementVNode("td", null, _toDisplayString($data.phoneObj.product.userProductName), 1)]), _createElementVNode("tr", null, [_hoisted_34, _createElementVNode("td", null, _toDisplayString($data.phoneObj.product.monthFee) + " 元/月", 1)]), $data.phoneObj.product.packageOther ? (_openBlock(), _createElementBlock("tr", _hoisted_35, [_hoisted_36, _createElementVNode("td", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.phoneObj.product.packageOther.split(/[;；]/), function (item, index) {
        return _openBlock(), _createElementBlock("p", {
          key: 'other_' + index
        }, _toDisplayString(item), 1);
      }), 128))])])) : _createCommentVNode("", true), _createElementVNode("tr", null, [_hoisted_37, _createElementVNode("td", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.phoneObj.product.inPackageContent.split(/[;；]/), function (item, index) {
        return _openBlock(), _createElementBlock("p", {
          key: 'in_' + index
        }, _toDisplayString(item), 1);
      }), 128))])]), _createElementVNode("tr", null, [_hoisted_38, _createElementVNode("td", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.phoneObj.product.outPackageFee.split(/[;；]/), function (item, index) {
        return _openBlock(), _createElementBlock("p", {
          key: 'out_' + index
        }, _toDisplayString(item), 1);
      }), 128))])]), $data.phoneObj.lowConsume != 0 || $data.phoneObj.onlineMonths != 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [_hoisted_40, _createElementVNode("td", null, [$data.phoneObj.lowConsume != 0 ? (_openBlock(), _createElementBlock("p", _hoisted_41, [_hoisted_42, _createElementVNode("span", _hoisted_43, _toDisplayString($data.phoneObj.lowConsume), 1), _hoisted_44])) : _createCommentVNode("", true), $data.phoneObj.onlineMonths != 0 ? (_openBlock(), _createElementBlock("p", _hoisted_45, [_hoisted_46, _createElementVNode("span", _hoisted_47, _toDisplayString($data.phoneObj.onlineMonths), 1), _hoisted_48])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]), _hoisted_49, _createVNode(_component_van_form, {
        onSubmit: $options.submitOrder
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_cell_group, {
            inset: ""
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_van_field, {
                modelValue: $data.orderObj.userInfo.userName,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) {
                  return $data.orderObj.userInfo.userName = $event;
                }),
                rules: [{
                  required: true,
                  message: '请正确填写真实姓名',
                  validator: $options.nameValidator
                }],
                label: "真实姓名",
                name: "姓名",
                placeholder: "请输入开户人真实姓名",
                required: ""
              }, null, 8, ["modelValue", "rules"]), _createVNode(_component_van_field, {
                modelValue: $data.orderObj.userInfo.idCard,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) {
                  return $data.orderObj.userInfo.idCard = $event;
                }),
                rules: [{
                  required: true,
                  message: '请正确填写身份证号',
                  validator: $options.idCardValidator
                }],
                label: "身份证号",
                name: "身份证号",
                placeholder: "请输入开户人真实身份证",
                required: ""
              }, null, 8, ["modelValue", "rules"]), _createVNode(_component_van_field, {
                modelValue: $data.areaStr,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) {
                  return $data.areaStr = $event;
                }),
                "is-link": "",
                label: "收货地址",
                name: "收货地址",
                placeholder: "请选择收货的省 / 城市 / 区县",
                readonly: "",
                required: "",
                onClick: _cache[14] || (_cache[14] = function ($event) {
                  return $data.addressShow = true;
                })
              }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
                modelValue: $data.orderObj.userInfo.address,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = function ($event) {
                  return $data.orderObj.userInfo.address = $event;
                }),
                rules: [{
                  required: true,
                  message: '请输入正确的收货详细地址'
                }],
                label: "详细地址",
                name: "详细地址",
                placeholder: "请输入收货的详细地址",
                required: ""
              }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
                modelValue: $data.orderObj.userInfo.phone,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = function ($event) {
                  return $data.orderObj.userInfo.phone = $event;
                }),
                rules: [{
                  required: true,
                  message: '请正确填写联系电话',
                  validator: $options.phoneValidator
                }],
                label: "联系电话",
                name: "联系电话",
                placeholder: "请输入开户人真实联系电话",
                required: "",
                type: "tel"
              }, null, 8, ["modelValue", "rules"]), _createVNode(_component_van_field, {
                rules: [{
                  required: true,
                  message: '请阅读并勾选'
                }],
                name: "checkbox"
              }, {
                input: _withCtx(function () {
                  return [_createVNode(_component_van_checkbox, {
                    modelValue: $data.orderObj.checked,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = function ($event) {
                      return $data.orderObj.checked = $event;
                    }),
                    shape: "square"
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_50, $data.phoneObj.optId == 2 ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        onClick: _cache[17] || (_cache[17] = function ($event) {
                          return $data.showUnicomProtocol = true;
                        })
                      }, [_hoisted_51, _hoisted_52, _hoisted_53, $data.phoneObj.lowConsume > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_54, _hoisted_57)) : _createCommentVNode("", true)])) : $data.phoneObj.optId == 3 ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        onClick: _cache[18] || (_cache[18] = function ($event) {
                          return $data.showTelcomProtocol = true;
                        })
                      }, _hoisted_61)) : $data.phoneObj.optId == 5 ? (_openBlock(), _createElementBlock("span", {
                        key: 2,
                        onClick: _cache[19] || (_cache[19] = function ($event) {
                          return $data.showBroadProtocol = true;
                        })
                      }, _hoisted_63)) : $data.phoneObj.optId == 1 ? (_openBlock(), _createElementBlock("span", {
                        key: 3,
                        onClick: _cache[20] || (_cache[20] = function ($event) {
                          return $options.loadProtocol();
                        })
                      }, _hoisted_69)) : _createCommentVNode("", true)];
                    }),
                    _: 1
                  }, 8, ["modelValue"])];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createElementVNode("div", _hoisted_70, [_createElementVNode("div", _hoisted_71, [_createElementVNode("span", _hoisted_72, [_hoisted_73, _createElementVNode("span", _hoisted_74, "￥ " + _toDisplayString($data.phoneObj.costPrice + $data.phoneObj.fee), 1)]), _createElementVNode("span", {
            style: {
              "font-size": "0.2rem",
              "color": "#F37B1D"
            },
            onClick: _cache[22] || (_cache[22] = function ($event) {
              return $data.showPriceDetail = !$data.showPriceDetail;
            })
          }, [_hoisted_75, $data.showPriceDetail ? (_openBlock(), _createBlock(_component_van_icon, {
            key: 0,
            name: "arrow-up"
          })) : (_openBlock(), _createBlock(_component_van_icon, {
            key: 1,
            name: "arrow-down"
          }))]), _createVNode(_component_van_button, {
            disabled: $data.submitBtnFlag,
            class: "pay_btn",
            "native-type": "submit"
          }, {
            default: _withCtx(function () {
              return [_hoisted_76];
            }),
            _: 1
          }, 8, ["disabled"]), _withDirectives(_createElementVNode("div", _hoisted_77, [_createElementVNode("div", _hoisted_78, [_hoisted_79, _createElementVNode("span", null, "￥ " + _toDisplayString($data.phoneObj.costPrice), 1)]), _createElementVNode("div", _hoisted_80, [_hoisted_81, _createElementVNode("span", null, "￥ " + _toDisplayString($data.phoneObj.fee), 1)])], 512), [[_vShow, $data.showPriceDetail]])])])];
        }),
        _: 1
      }, 8, ["onSubmit"]), _hoisted_82, _createElementVNode("div", null, [$data.phoneObj.optId == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_83, [$data.phoneObj.province == '安徽' ? (_openBlock(), _createBlock(_component_van_image, {
        key: 0,
        src: require('@/assets/images/anhui_unicom_bsp.png')
      }, null, 8, ["src"])) : (_openBlock(), _createBlock(_component_van_image, {
        key: 1,
        src: require('@/assets/images/changsha_jd_unicom_bsp.png')
      }, null, 8, ["src"]))])) : $data.phoneObj.optId == 3 ? (_openBlock(), _createBlock(_component_van_image, {
        key: 1,
        src: require('@/assets/images/telcom_bsp.png')
      }, null, 8, ["src"])) : $data.phoneObj.optId == 5 ? (_openBlock(), _createBlock(_component_van_image, {
        key: 2,
        src: require('@/assets/images/broadnet_bsp.png')
      }, null, 8, ["src"])) : _createCommentVNode("", true), $data.phoneObj.province == '广东' && $data.phoneObj.optId == 2 ? (_openBlock(), _createBlock(_component_van_image, {
        key: 3,
        src: "https://m.52haoma.com/images/gd_fz.jpg"
      })) : _createCommentVNode("", true), _createVNode(_component_van_image, {
        src: "https://m.52haoma.com/images/yizhengtc.png"
      }), _createElementVNode("div", {
        onClick: _cache[23] || (_cache[23] = function ($event) {
          return $data.showYizengtc2 = !$data.showYizengtc2;
        }),
        style: {
          "text-align": "center",
          "margin": "0.2rem"
        }
      }, "↓↓↓ 查看更多 ↓↓↓"), $data.showYizengtc2 ? (_openBlock(), _createBlock(_component_van_image, {
        key: 4,
        src: "https://m.52haoma.com/images/yizhengtc2.jpg"
      })) : _createCommentVNode("", true)]), _hoisted_84])];
    }),
    _: 1
  }, 8, ["show"]), _hoisted_85, _createElementVNode("div", {
    class: "goTop",
    onClick: _cache[25] || (_cache[25] = function () {
      return $options.backtop && $options.backtop.apply($options, arguments);
    })
  }, [_createVNode(_component_van_icon, {
    name: "back-top"
  })]), _createVNode(_component_van_popup, {
    show: $data.addressShow,
    "onUpdate:show": _cache[27] || (_cache[27] = function ($event) {
      return $data.addressShow = $event;
    }),
    position: "bottom",
    round: ""
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_picker, {
        style: {
          "width": "7.5rem",
          "margin": "0 auto"
        },
        columns: $data.addressOptions,
        title: "请选择收货地址的 省 / 市 / 区县",
        onCancel: _cache[26] || (_cache[26] = function ($event) {
          return $data.addressShow = false;
        }),
        onConfirm: $options.confirmAddress
      }, null, 8, ["columns", "onConfirm"])];
    }),
    _: 1
  }, 8, ["show"]), _createVNode(_component_UnicomInNetProtocol, {
    showUnicomProtocol: $data.showUnicomProtocol,
    "onUpdate:showUnicomProtocol": _cache[28] || (_cache[28] = function ($event) {
      return $data.showUnicomProtocol = $event;
    }),
    "ad-order": $data.orderObj
  }, null, 8, ["showUnicomProtocol", "ad-order"]), _createVNode(_component_TelcomNetProtocol, {
    showTelcomProtocol: $data.showTelcomProtocol,
    "onUpdate:showTelcomProtocol": _cache[29] || (_cache[29] = function ($event) {
      return $data.showTelcomProtocol = $event;
    })
  }, null, 8, ["showTelcomProtocol"]), _createVNode(_component_BroadNetProtocol, {
    showBroadProtocol: $data.showBroadProtocol,
    "onUpdate:showBroadProtocol": _cache[30] || (_cache[30] = function ($event) {
      return $data.showBroadProtocol = $event;
    })
  }, null, 8, ["showBroadProtocol"]), _createVNode(_component_MobileNetProtocol, {
    showMobileProtocol: $data.showMobileProtocol,
    "onUpdate:showMobileProtocol": _cache[31] || (_cache[31] = function ($event) {
      return $data.showMobileProtocol = $event;
    }),
    protocolContent: $data.protocol[$data.queryObj.provinceCode]
  }, null, 8, ["showMobileProtocol", "protocolContent"])], 64);
}